// extracted by mini-css-extract-plugin
module.exports = {"videoLink":"_2X9na"};